import { Icon } from '@chakra-ui/react';
import { IoArrowBackCircle } from 'react-icons/io5';

export const ExitSearchIcon = () => (
  <Icon as={IoArrowBackCircle} fontSize="24px" display="block" color="clay.0" />
);
